"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACTIVITY_STREAM_AT_MENTION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ACTIVITY_STREAM_AT_MENTION;
  }
});
Object.defineProperty(exports, "ADVANCED_DOCUMENT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ADVANCED_DOCUMENT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "AGILE_AT_SCALE_ADVANCED_WORKFLOW_ENGINE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AGILE_AT_SCALE_ADVANCED_WORKFLOW_ENGINE;
  }
});
Object.defineProperty(exports, "AGILE_METHODOLOGIES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AGILE_METHODOLOGIES;
  }
});
Object.defineProperty(exports, "BASELINING_KPIS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BASELINING_KPIS;
  }
});
Object.defineProperty(exports, "BUDGET_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BUDGET_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CALENDAR_VIEW", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CALENDAR_VIEW;
  }
});
Object.defineProperty(exports, "COLLABORATIVE_PROJECT_PLANNING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.COLLABORATIVE_PROJECT_PLANNING;
  }
});
Object.defineProperty(exports, "DUE_DATES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DUE_DATES;
  }
});
Object.defineProperty(exports, "EASY_ADMINISTRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EASY_ADMINISTRATION;
  }
});
Object.defineProperty(exports, "EFFECTIVE_REPORTING_ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EFFECTIVE_REPORTING_ANALYTICS;
  }
});
Object.defineProperty(exports, "EFFECTIVE_TIME_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EFFECTIVE_TIME_TRACKING;
  }
});
Object.defineProperty(exports, "EFFICIENT_WORKLOAD_PERFORMANCE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EFFICIENT_WORKLOAD_PERFORMANCE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "GANTT_CHARTS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.GANTT_CHARTS;
  }
});
Object.defineProperty(exports, "IDEA_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.IDEA_MANAGEMENT;
  }
});
Object.defineProperty(exports, "INSIGHTFUL_VIEWS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INSIGHTFUL_VIEWS;
  }
});
Object.defineProperty(exports, "MILESTONE_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MILESTONE_TRACKING;
  }
});
Object.defineProperty(exports, "PORTFOLIO_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PORTFOLIO_MANAGEMENT;
  }
});
Object.defineProperty(exports, "PROJECT_MANAGEMENT_WITH_BOARDS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PROJECT_MANAGEMENT_WITH_BOARDS;
  }
});
Object.defineProperty(exports, "PROJECT_TAGS_FOLDERS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PROJECT_TAGS_FOLDERS;
  }
});
Object.defineProperty(exports, "PROJECT_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PROJECT_TRACKING;
  }
});
Object.defineProperty(exports, "RESOURCE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.RESOURCE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "TASK_CREATION_ASSIGNMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TASK_CREATION_ASSIGNMENT;
  }
});
Object.defineProperty(exports, "TASK_PRIORITIZATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TASK_PRIORITIZATION;
  }
});
Object.defineProperty(exports, "TASK_PROGRESS_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TASK_PROGRESS_TRACKING;
  }
});
Object.defineProperty(exports, "THREE_PANE_PROJECT_VIEW", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.THREE_PANE_PROJECT_VIEW;
  }
});
Object.defineProperty(exports, "TO_DO_LISTS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TO_DO_LISTS;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Project.js
// module id = 578
// module chunks = 209 210 211 212 213